import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class EventosClienteService {

  constructor(private afDB: AngularFireDatabase) {}

  public normalizarSiglasCliente(nombreCliente: string): string {
    const nombre = (nombreCliente || '').trim().toUpperCase();
    const sinAcentos = nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const soloLetras = sinAcentos.replace(/[^A-Z\s]/g, '').replace(/\s+/g, ' ').trim();
    const sinEspacios = soloLetras.replace(/\s/g, '');
    const siglas = (sinEspacios + 'XXX').substring(0, 3);
    console.log('[EventosClienteService] normalizarSiglasCliente', { nombreCliente, siglas });
    return siglas;
  }

  public formatearConsecutivo(numero: number): string {
    return ('000' + numero).slice(-3);
  }

  public obtenerEventoCliente(clienteId: string, eventoId: string) {
    console.log('[EventosClienteService] obtenerEventoCliente', { clienteId, eventoId });
    return this.afDB.object(`clientes/${clienteId}/eventos/${eventoId}`);
  }

  public buscarEventosCliente(clienteId: string, termino: string): Observable<any[]> {
    return this.afDB.object(`clientes/${clienteId}/eventos`).valueChanges().map((eventosObj: any) => {
      const eventos = [];
      if (eventosObj) {
        Object.keys(eventosObj).forEach(id => {
          eventos.push({ id, ...eventosObj[id] });
        });
      }
      const q = (termino || '').toLowerCase().trim();
      if (!q) {
        return eventos;
      }
      return eventos.filter((e: any) => {
        const byId = (e.id || '').toLowerCase().indexOf(q) >= 0;
        const byNombre = (e.nombre || '').toLowerCase().indexOf(q) >= 0;
        return byId || byNombre;
      });
    });
  }

  public crearEventoCliente(clienteId: string, nombreCliente: string, nombreEvento: string): Promise<any> {
    const siglas = this.normalizarSiglasCliente(nombreCliente);
    const ref = this.afDB.database.ref(`clientes/${clienteId}/eventosConsecutivo`);

    console.log('[EventosClienteService] crearEventoCliente - inicio', { clienteId, nombreCliente, nombreEvento, siglas });

    return ref.transaction((current: any) => {
      const actual = current || 0;
      return actual + 1;
    }).then((tx: any) => {
      const consecutivo = tx.snapshot.val();
      const eventoId = `EV${siglas}-${this.formatearConsecutivo(consecutivo)}`;
      const evento = {
        id: eventoId,
        nombre: nombreEvento,
        servicios: []
      };

      const multipath = {};
      multipath[`clientes/${clienteId}/eventos/${eventoId}`] = evento;
      multipath[`clientes/${clienteId}/eventosConsecutivo`] = consecutivo;

      console.log('[EventosClienteService] crearEventoCliente - guardar', { eventoId, consecutivo, evento });
      return this.afDB.object('/').update(multipath).then(() => ({ eventoId, evento }));
    });
  }

  public vincularIdTrostenAEvento(clienteId: string, eventoId: string, idTrosten: string): Promise<any> {
    const ref = this.afDB.database.ref(`clientes/${clienteId}/eventos/${eventoId}/servicios`);
    console.log('[EventosClienteService] vincularIdTrostenAEvento - inicio', { clienteId, eventoId, idTrosten });

    return ref.transaction((current: any) => {
      let servicios = current || [];
      if (!Array.isArray(servicios)) {
        servicios = [];
      }
      if (servicios.indexOf(idTrosten) < 0) {
        servicios.push(idTrosten);
      }
      return servicios;
    }).then((tx: any) => {
      console.log('[EventosClienteService] vincularIdTrostenAEvento - fin', { committed: tx.committed, servicios: tx.snapshot.val() });
      return tx;
    });
  }

  public desvincularIdTrostenDeEvento(clienteId: string, eventoId: string, idTrosten: string): Promise<any> {
    const ref = this.afDB.database.ref(`clientes/${clienteId}/eventos/${eventoId}/servicios`);
    console.log('[EventosClienteService] desvincularIdTrostenDeEvento - inicio', { clienteId, eventoId, idTrosten });

    return ref.transaction((current: any) => {
      let servicios = current || [];
      if (!Array.isArray(servicios)) {
        servicios = [];
      }
      servicios = servicios.filter((id: string) => id !== idTrosten);
      return servicios;
    }).then((tx: any) => {
      console.log('[EventosClienteService] desvincularIdTrostenDeEvento - fin', { committed: tx.committed, servicios: tx.snapshot.val() });
      return tx;
    });
  }
}




// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/eventos-cliente.service.ts